import Vue from "vue";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
// import {
//   TooltipPlugin,
//   ModalPlugin,
//   ToastPlugin,
//   CardPlugin,
//   CollapsePlugin,
//   ButtonPlugin,
//   ButtonGroupPlugin,
//   FormDatepickerPlugin,
//   FormSelectPlugin,
//   FormPlugin,
//   FormGroupPlugin,
//   FormInputPlugin,
//   FormTextareaPlugin,
//   FormFilePlugin,
//   FormCheckboxPlugin,
//   FormRadioPlugin,
//   InputGroupPlugin,
//   TablePlugin,
//   LayoutPlugin,
//   IconsPlugin,
//   ProgressPlugin,
//   ListGroupPlugin,
//   EmbedPlugin,
//   PaginationPlugin,
//   PopoverPlugin,
//   LinkPlugin,
//   AlertPlugin,
// } from "bootstrap-vue";
import "bootstrap/dist/js/bootstrap.min.js";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap-vue/dist/bootstrap-vue.css";

// Vue.use(ModalPlugin);
// Vue.use(ToastPlugin);
// Vue.use(TooltipPlugin);
// Vue.use(CardPlugin);
// Vue.use(CollapsePlugin);
// Vue.use(ButtonPlugin);
// Vue.use(ButtonGroupPlugin);
// Vue.use(FormPlugin);
// Vue.use(FormGroupPlugin);
// Vue.use(FormInputPlugin);
// Vue.use(FormTextareaPlugin);
// Vue.use(FormSelectPlugin);
// Vue.use(FormDatepickerPlugin);
// Vue.use(FormFilePlugin);
// Vue.use(FormCheckboxPlugin);
// Vue.use(FormRadioPlugin);
// Vue.use(InputGroupPlugin);
// Vue.use(TablePlugin);
// Vue.use(LayoutPlugin);
// Vue.use(ProgressPlugin);
// Vue.use(ListGroupPlugin);
// Vue.use(EmbedPlugin);
// Vue.use(PaginationPlugin);
// Vue.use(PopoverPlugin);
// Vue.use(LinkPlugin);
// Vue.use(AlertPlugin);
Vue.use(BootstrapVue, {
  BTable: {
    outlined: true,
    small: true,
    showEmpty: true,
    striped: true,
  },
  BButton: {
    variant: "primary",
  },
});
Vue.use(IconsPlugin);
